import script from "./MyAgentList.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAgentList.vue?vue&type=script&setup=true&lang=js"

import "./MyAgentList.vue?vue&type=style&index=0&id=225d5295&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-225d5295"]])

export default __exports__